import { render, staticRenderFns } from "./ProjectNotes.vue?vue&type=template&id=c1159388&scoped=true"
import script from "./ProjectNotes.vue?vue&type=script&lang=js"
export * from "./ProjectNotes.vue?vue&type=script&lang=js"
import style0 from "./ProjectNotes.vue?vue&type=style&index=0&id=c1159388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1159388",
  null
  
)

export default component.exports